import { Link } from 'react-router';
import { useDocumentTitle } from '../components/ui.tsx';

export function NotFound() {
  useDocumentTitle('Sivua ei löytynyt');
  return (
    <div className="page page-narrow">
      <div className="card">
        <h1>Sivua ei löytynyt</h1>
        <p className="muted">Osoite on ehkä vanhentunut tai kirjoitettu väärin.</p>
        <Link className="btn btn-primary" to="/">
          Etusivulle
        </Link>
      </div>
    </div>
  );
}
